import { render, staticRenderFns } from "./SkeletonLoaders.vue?vue&type=template&id=5b307c40&"
import script from "./SkeletonLoaders.vue?vue&type=script&lang=js&"
export * from "./SkeletonLoaders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports